/**
 * Default system fonts based on current platform.
 *
 * @remarks If you are using Expo, use `Constants.systemFonts` instead.
 */
const defaultSystemFonts = ['Arial', 'Courier New', 'Georgia'];
export default defaultSystemFonts;
